import { AbstractRepository } from '@/repositories/abstract-repository';
import { Permission } from '@/staff/models/user-permission-models';

export class PermissionsRepository extends AbstractRepository<Permission> {
    readonly endpoint = 'permissions';
}
